import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import DraftComponent from './../../../../../estimations/editor/tools/DraftComponent/DraftComponent';
import { convertToRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

import * as actions from './../../../../actions/actions';

class Text extends React.Component {
    constructor(props) {
        super(props);
        this.state = { text: this.props.widget.value };
    }

    render() {
        const { mode, widget, actions } = this.props;
        let textContent;

        switch (widget.type) {
        case 'Header':
            textContent = `<h1>${this.state.text}</h1>`;
            break;
        case 'Subheader':
            textContent = `<h2>${this.state.text}</h2>`;
            break;
        case 'Paragraph':
            textContent = `<p>${this.state.text}</p>`;
            break;
        default:
            textContent = `<div>${this.state.text}</div>`;
        }

        return (
            <div>
                {
                    (mode === 'EDIT') ? <DraftComponent content={textContent} onChange={(state) => actions.setTextWidgetValue(widget.id, stateToHTML(state))} activeEditing advanced activeTools />
                    : <span dangerouslySetInnerHTML={{ __html: widget.value }} />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mode: state.app.mode,
    tools: state.tools,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Text.propTypes = {
    widget: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Text);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Text/Text.jsx